import React, {
    useCallback,
    useContext
} from 'react';

import PropTypes from 'prop-types';

import {
    Cell,
    Legend,
    PieChart,
    Pie,
    ResponsiveContainer
} from 'recharts';

import ExportContext from '../../contexts/exportContext.js';

export default function Donut({colors, data, dataKey = 'value', height = 318, nameKey = 'name', legendDataKey = 'value', width = '100%'}) {
    const isExporting = Boolean(useContext(ExportContext));

    const getColor = useCallback((datum, index) => {
        if (colors) {
            return colors(datum, index);
        }
        return RivalIQ.utils.color.donut()(datum, index);
    }, [colors]);

    return (
        <>
            <section className='tlw-w-2/3'>
                <ResponsiveContainer
                    width={width}
                    height={height}
                >
                    <PieChart
                        margin={{
                            right: 24
                        }}
                    >
                        <Pie
                            data={data}
                            innerRadius='40%'
                            outerRadius='90%'
                            startAngle={90}
                            endAngle={-450}
                            isAnimationActive={!isExporting}
                            paddingAngle={1}
                            dataKey={dataKey}
                            style={{
                                outline: 'none'
                            }}
                        >
                            {data.map((datum, index) => {
                                return (
                                    <Cell
                                        key={`cell-${index}`}
                                        fill={getColor(datum, index)}
                                    />
                                );
                            })}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
            </section>
            <section className='tlw-w-1/3'>
                <Legend
                    layout='vertical'
                    verticalAlign='top'
                    align='right'
                    iconSize='11'
                    payload={
                        data.map(
                            (datum, index) => ({
                                id: `item-${index}`,
                                type: 'square',
                                value: [datum[nameKey], datum[legendDataKey]],
                                color: getColor(datum, index),
                                item: datum
                            })
                        )
                    }
                    formatter={(value) => <span className={`tlw-mb-5 tlw-inline-block tlw-text-sm tlw-text-gray-900`}>{value[0]}: &nbsp;<strong>{value[1]}</strong></span>}
                />
            </section>
        </>
    );
}

Donut.propTypes = {
    dataKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    data: PropTypes.array.isRequired,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    legendDataKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nameKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
